<form [formRoot]="loginForm" class="w-full max-w-2xl">
    <div class="bg-white rounded-4xl shadow-2xl p-10">
        <div class="text-center">
            <h2 class="text-4xl font-bold mt-8"> Bienvenido</h2>
            <p class="text-gray-500 mt-2 mb-8">
                Inicia sesión para continuar
            </p>
        </div>
        <!-- Usuario -->
        <ui-input label="Usuario" placeholder="Ingresa tu usuario" [formField]="loginForm.usuario" [icon]="userIcon" size="lg"
            errorMessage="El usuario es requerido">
        </ui-input>

        <!-- Password -->
        <div class="mt-3">
            <ui-input label="Contraseña" placeholder="Ingresa tu contraseña" [formField]="loginForm.password" [icon]="lockIcon" type="password" size="lg"
                errorMessage="La contraseña es requerida">
            </ui-input>
        </div>

        <!-- Opciones -->

        <div class="flex justify-between items-center mt-4 mb-6">
            <ui-checkbox [formField]="loginForm.remember">
                Recordarme
            </ui-checkbox>
            <a routerLink="auth/recovery-password"
                class="text-primary-variant font-medium cursor-pointer hover:underline">
                ¿Olvidaste tu contraseña?
            </a>
        </div>

        <!-- Errores controlados por el backend (400) -->
        @if (formError(); as error) {
        <ui-alert variant="error" class="mb-4 block">
            @for (message of error.messages; track message) {
            <p>{{ message }}</p>
            }
        </ui-alert>
        }

        <!-- Login -->

        <ui-button type="submit" text="Iniciar sesión" [iconRight]="arrowRightIcon" [fullWidth]="true" size="lg"
            [loading]="isLoggingIn()" [disabled]="isBusy()">
        </ui-button>

        <!-- Divider -->
        <div class="flex items-center my-6">
            <div class="flex-1 border-t border-gray-300"></div>
            <span class="px-4 text-gray-400">
                o continúa con
            </span>
            <div class="flex-1 border-t border-gray-300"></div>
        </div>
        <!-- Microsoft -->
        <div class="flex items-center justify-center">
            <ui-button variant="outlined" text="Iniciar con Microsoft" [iconLeft]="mailIcon"
                [iconRight]="arrowRightIcon" [fullWidth]="true" size="lg"
                [loading]="isLoggingInWithMicrosoft()" [disabled]="isBusy()" (clicked)="loginWithMicrosoft()">
            </ui-button>
        </div>


    </div>

</form>